export const UiConfigEndpoints = {
  loginAppearance: '/public/interface/login',
  edit: '/preferences/config/ui',
  details: '/preferences/config/ui',
  appearance: '/preferences/config/ui/appearance',
};
